import {AfterViewInit, Component, ElementRef, Input ,OnDestroy, OnInit, ViewChild, OnChanges} from '@angular/core';

@Component({
  selector: 'app-simple-line',
  templateUrl: './simple-line.component.html',
  styleUrls: ['./simple-line.component.css']
})
export class SimpleLineComponent implements OnInit,AfterViewInit, OnChanges, OnDestroy  {

  resizeInterval: any;
  graphElements: any[];
  @ViewChild('flexContent', {static:true}) flexContent;
  @Input ('data') data
  @Input() settings: Object = { };
  view = [];
  color = [];
  autoScale= true;
  results=[];
  xAxis = true
  yAxis= true 
  showXAxisLabel = false ;
  showYAxisLabel = true ;
  @Input('legend') legend = false;
  @Input('yAxisLabel') yAxisLabel ="'No. of Emails'"
  @Input('colorScheme') colorScheme;
  constructor() { }

  ngOnInit() {
   
  }
  ngOnChanges() {
    this.onResize();
  }
  onResize() {
    // calling after 300 ms instead of every ms
    clearInterval(this.resizeInterval);
    this.resizeInterval = setInterval(() => {
      this.setGraphSize();
      clearInterval(this.resizeInterval);
    }, 300);
  }

  setGraphSize() {
    // check if graph containers are available
    if (!this.graphElements || (this.graphElements && this.graphElements.length === 0)) {
      // try to cache graph elements
      this.cacheGraphElements();

      // if graph elements are still not available, try to get after some time
      if (!this.graphElements || (this.graphElements && this.graphElements.length === 0)) {
        this.onResize();
        return;
      }
    }

    setTimeout(() => {
      // hide all graphs for getting correct width
      this.graphElements.forEach(element => {
        element.classList.add('graph-fix');
      });
      // 25px padding * 2 sides
      this.view = [this.flexContent.nativeElement.offsetWidth - (25 * 2), 280];
      // after getting correct width show all graphs
      this.graphElements.forEach(element => {
        element.classList.remove('graph-fix');
      });
    }, 100);
    
  }
  ngAfterViewInit(): void {
    this.setGraphSize();
  }

  ngOnDestroy(): void {
    clearInterval(this.resizeInterval);
  }

  cacheGraphElements() {
    this.graphElements = this.flexContent.nativeElement.querySelectorAll('.chart-container');
  }
}
